<app-uig-terms-conditions-note [hideButtons]="true"></app-uig-terms-conditions-note>

@if (!isRestricted) {
  <button
    type="button"
    (click)="submitOrder()"
    class="btn btn-primary btn-block"
    >
    {{ 'uigCheckout.placeOrder' | cxTranslate }}
  </button>
}
